import axios from 'axios';

const syncStepEmails = ({ stepId, emails }) => {
  return axios.put(`conversations/builder/steps/${stepId}/emails/sync`, {
    ids: emails
  });
};

export { syncStepEmails };
